import React, { useContext, useEffect } from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'
import { SiteConfigContext } from '../SiteConfigProvider'
import { isBrowser, useScript } from '@jelly/utils'

const QtWrapper = styled.div`
	margin: 4rem 0;
`

/**
 * This component is for the QT Widget code
 * Will create a reference to load the qt widget
 *
 * @param {string} qtOfferGroupId Group id - 2 currently correlates to the "Small Businesses" group
 *
 */
export function QtWidget({ qtOfferGroupId = '2', qtViewType = 'default' }) {
	const [loaded, error] = useScript('https://widgets.business.com/qt-widget-v2/bdcQtWidget.min.js')

	const {
		siteConstants: { QT_ADMIN_PUB_ID, WIDGET_ENV },
	} = useContext(SiteConfigContext)

	useEffect(() => {
		if (error) {
			return console.warn('Failed to load bdcQtWidget.min.js')
		}

		if (isBrowser() && loaded) {
			try {
				window.bdcQtWidget.init()
			} catch (error) {
				console.warn(error)
			}
		}
	}, [loaded, error])

	return (
		<QtWrapper>
			<div
				data-bdc-qt-widget
				data-qt-pub-id={QT_ADMIN_PUB_ID}
				data-qt-offer-group-id={qtOfferGroupId}
				data-qt-stage={WIDGET_ENV}
				data-qt-view-type={qtViewType}
			/>
		</QtWrapper>
	)
}

QtWidget.propTypes = {
	qtOfferGroupId: string.isRequired,
}
